export enum EBatchImportLogStatus {
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum EBatchImportResultAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  REMOVED = 'REMOVED',
}

// Comes from the uploaded file. Users without the "view patient identities" permission get censored values
// (******, **/**/****) from the server: nothing to handle client-side.
export type TBatchImportPatient = {
  remoteId?: string
  firstname?: string
  lastname?: string
  phone?: string
  mail?: string
  birthdate?: string
  locale?: string
  gender?: string
  isArchived?: boolean
}

// Raw shape sent by the backend; `error` is scrubbed of patient values for users without the permission
export type TBatchImportLogError = {
  type: 'MEDEVENT' | 'PATIENT' | 'OTHER'
  remoteId?: string
  error: string
}

export type TBatchImportLogResult = {
  interopLogId: number
  status: EBatchImportLogStatus
  resultAction?: EBatchImportResultAction
  PatientId?: number
  PatientMedEventId?: number
  // Line of the uploaded file this result comes from
  sourceLine?: number
  patient?: TBatchImportPatient
  errors?: TBatchImportLogError[] | null
}

export type TBatchImportStatusResponse = {
  logs: Record<string, TBatchImportLogResult>
}

export type TBatchImportSummary = {
  batchImportToken: string
  authorUserId: number
  origin: string
  // Shown raw by the backend (not anonymized)
  filename?: string
  dataCount: number
  createdAt: string
}
